import styled, {css} from 'styled-components'
import {Flexbox} from '@components/ui/flexbox/FlexBox.tsx'

type StyledInputWrapperProps = {
    touched: boolean
    hasError: boolean
}

export const StyledInputWrapper = styled(Flexbox)<StyledInputWrapperProps>`
    ${({hasError, theme: {palette, shadows, spacing}}) => css`
        position: relative;
        background: ${palette.neutral.white};
        border: 1px solid ${palette.neutral['300']};
        border-radius: ${spacing * 2}px;
        width: 100%;
        transition: ease-in-out 200ms;
        cursor: pointer;

        &:has(input:disabled) {
            background: ${palette.neutral['100']};
            color: ${palette.neutral['500']};
            cursor: not-allowed;
        }

        &:not(&:has(input:disabled)):hover {
            border: 1px solid ${hasError ? palette.danger['300'] : palette.green['400']};
            box-shadow: ${`${shadows.xs}, 0px 0px 0px 4px ${
                hasError ? palette.danger['100'] : palette.primary['100']
            }`};
        }

        ${hasError &&
        css`
            border: 1px solid ${palette.danger['300']};
        `};
    `}
`
